export default __webpack_public_path__ + "08d5e7c8.jpg";